import { captureException } from "@sentry/svelte"

export function sendBeacon(route: string, data: FormData) {
  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content

  if (!csrfToken) {
    captureException(new Error("CSRF token not found in the document"))
    return
  }

  data.append("_token", csrfToken)
  navigator.sendBeacon(route, data)
}
